export const odluka_pokrice_gubitka= {
    templateId: 206.1,
    category: 4,
    templateTitle: 'Odluka o pokriću gubitka',
    templateDescription: `<p>Ukoliko poduzetnik ostvari gubitak, isti se pokriva prema odredbama Zakona o trgovačkim društvima te Zakona o računovodstvu.  Odluka o pokriću gubitka predstavlja javni dio registra GFI te istu donose članovi društva na skupštini uz pridržavanje obveza iz Zakona o trgovačkim društvima i Zakona o računovodstvu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    
    <p>Odluka o pokriću gubitka, prema Zakonu o računovodstvu predstavlja javni dio registra godišnjih financijskih izvještaja.</p>
    <p>O utvrđivanju godišnjih financijskih izvještaja i podjeli dobiti/pokriću gubitka odlučuju članovi društva na skupštini.</p>
    <p>Glavna skupština odlučuje o pitanjima koja su izričito određena zakonom i osnivačkim aktom društva, a osobito o upotrebi dobiti/pokriću gubitka.</p>
    <p>Odluku o pokriću gubitka ne može donijeti uprava ili direktor. Oni mogu dati samo prijedlog za raspodjelu dobiti odnosno pokriće gubitka.</p>
    <p>Gubitak društva s ograničenom odgovornošću obvezno se pokriva iz:  iz zadržane dobiti, rezervi, na teret upisanog kapitala sukladno odredbama ZTD-a, dobiti koja se planira realizirati u budućim razdobljima.  </p>
    <p>Zakonima nije propisan rok za pokriće gubitka.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o trgovačkim društvima, Zakon o računovodstvu.</p>
    `,
    sides: [
        {
            prefix: 'Na temelju odredbi Zakona o trgovačkim društvima i Zakona o računovodstvu,',
            signature: 'Predsjednik skupštine',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: " (u daljnjem tekstu: Društvo),",
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O POKRIĆU GUBITKA',
    noArticleNumbers: true,

    articles: [
     
      {
        title: '',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                editable: true,
                mandatory: true,
                content: 'Prema usvojenim financijskim izvještajima, Društvo je u 20__ godini ostvarilo gubitak od ________ kn.',
                value: '',
            }],
    },
  {
    title: '',
    mandatory: true,
    exampleContent: true,
    statements: [
        {
            type: 'choice',
            mandatory: true,
            editable: true,
            choices: [
                'Prethodno navedeni utvrđeni gubitak knjižiti će se kao preneseni gubitak ranijih godina, a pokriti će se iz zadržane dobiti ranijih godina.',
                'Prethodno navedeni utvrđeni gubitak knjižiti će se kao preneseni gubitak ranijih godina, a pokriti će se iz ostvarene dobiti u narednom razdoblju.',              ],
            placeholder: "Odaberite ovdje te potom izmijenite po želji...",  
        }
    ]
  },

    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Odluka se primjenjuje s danom donošenja.',
                value: '',
            }],
    },
 
   
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
          {
              type: 'input',
              mandatory: true,
              parts: [
                  {
                      type: 'text',
                      content: 'U'
                  },
                  {
                      type: 'input',
                      value: '',
                      placeholder: "Upišite mjesto.",
                      required: true
                  },
                  {
                      type: 'text',
                      content: ', dana'
                  },
                  {
                      type: 'date',
                      value: new Date(),
                      required: true
                  },
                  {
                      type: 'text',
                      content: 'godine.',
                  }
              ]
          },
      ]
  },
  {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
  },
  {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
          {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Dostaviti:\r\n1) Odjel knjigovodstva \r\n2) Arhiva',
              help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
          }
      ]
  },
],
};









// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/206.1_odluka_pokrice_gubitka.ts